export default __webpack_public_path__ + "static/media/gutermnn-full-brand-white.451ab3ee.png";